export default __webpack_public_path__ + "static/media/IMG_2243cropped.9528daf4.jpeg";